<template>
  <div data-v-d4d5716c="" class="contents">
    <nav data-v-d4d5716c="" class="nav_mobile_top">
      <div data-v-d4d5716c="" class="nav_content">
        <div data-v-d4d5716c="" class="nav_left nav_left1">
          <div data-v-d4d5716c="" class="back" @click="$router.go(-1)">
            <img
              data-v-d4d5716c=""
              src="../../assets/img/arrow_back.d5eef796-0de7d3ca.svg"
              alt=""
            />
          </div>
          <div data-v-d4d5716c="" class="nav_name2">{{ $t('languages') }}</div>
          <div data-v-d4d5716c="" class="start"></div>
        </div>
      </div>
    </nav>
    <div data-v-d4d5716c="" class="empty-box"></div>
    <div data-v-d4d5716c="" class="contents-box" style="padding: 0px 20px">
      <div data-v-d4d5716c="" class="menu-list">
        <div
          data-v-d4d5716c=""
          class="van-radio-group van-radio-group--horizontal"
          role="radiogroup"
        >
          <div data-v-d4d5716c="" class="menus" @click="selectlang('en')">
            <div data-v-d4d5716c="" class="title">English</div>
            <div data-v-d4d5716c="" class="redio">
              <div
                data-v-d4d5716c=""
                role="radio"
                class="van-radio van-radio--horizontal"
                tabindex="0"
                aria-checked="false"
              >
                <div
                  data-v-d4d5716c=""
                  class="van-radio__icon van-radio__icon--round"
                >
                  <div data-v-d4d5716c="" class="norm-radio">
                    <div
                      data-v-d4d5716c=""
                      class="norm-radio1"
                      :class="lang == 'en' ? 'redioActive' : ''"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div data-v-d4d5716c="" class="menus" @click="selectlang('jp')">
            <div data-v-d4d5716c="" class="title">日本語</div>
            <div data-v-d4d5716c="" class="redio">
              <div
                data-v-d4d5716c=""
                role="radio"
                class="van-radio van-radio--horizontal"
                tabindex="0"
                aria-checked="false"
              >
                <div
                  data-v-d4d5716c=""
                  class="van-radio__icon van-radio__icon--round"
                >
                  <div data-v-d4d5716c="" class="norm-radio">
                    <div
                      data-v-d4d5716c=""
                      class="norm-radio1"
                      :class="lang == 'jp' ? 'redioActive' : ''"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div data-v-d4d5716c="" class="menus" @click="selectlang('kr')">
            <div data-v-d4d5716c="" class="title">한국어</div>
            <div data-v-d4d5716c="" class="redio">
              <div
                data-v-d4d5716c=""
                role="radio"
                class="van-radio van-radio--horizontal"
                tabindex="0"
                aria-checked="false"
              >
                <div
                  data-v-d4d5716c=""
                  class="van-radio__icon van-radio__icon--round"
                >
                  <div data-v-d4d5716c="" class="norm-radio">
                    <div
                      data-v-d4d5716c=""
                      class="norm-radio1"
                      :class="lang == 'kr' ? 'redioActive' : ''"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div data-v-d4d5716c="" class="menus" @click="selectlang('zh')">
            <div data-v-d4d5716c="" class="title">简体中文</div>
            <div data-v-d4d5716c="" class="redio">
              <div
                data-v-d4d5716c=""
                role="radio"
                class="van-radio van-radio--horizontal"
                tabindex="0"
                aria-checked="false"
              >
                <div
                  data-v-d4d5716c=""
                  class="van-radio__icon van-radio__icon--round"
                >
                  <div data-v-d4d5716c="" class="norm-radio">
                    <div
                      data-v-d4d5716c=""
                      class="norm-radio1"
                      :class="lang == 'zh' ? 'redioActive' : ''"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            data-v-d4d5716c=""
            class="menus"
            style="border-bottom: 1px solid rgba(217, 217, 217, 0.2)"
            @click="selectlang('tw')"
          >
            <div data-v-d4d5716c="" class="title">繁體中文</div>
            <div data-v-d4d5716c="" class="redio">
              <div
                data-v-d4d5716c=""
                role="radio"
                class="van-radio van-radio--horizontal"
                tabindex="0"
                aria-checked="false"
              >
                <div
                  data-v-d4d5716c=""
                  class="van-radio__icon van-radio__icon--round"
                >
                  <div data-v-d4d5716c="" class="norm-radio">
                    <div
                      data-v-d4d5716c=""
                      class="norm-radio1"
                      :class="lang == 'tw' ? 'redioActive' : ''"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div data-v-d4d5716c="" class="button-box">
        <div data-v-d4d5716c="" class="buttons">
          <div data-v-d4d5716c="" class="confirm-button" @click="confirm">
            {{ $t('confirm') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '../../assets/css/index-c925edae.css'
import '../../assets/css/514.cbfba8eb.css'
export default {
  data() {
    return {
      list: [],
      shoumore: false,
      lang: localStorage.getItem('lang') || 'zh',
    }
  },
  created() {
    this.getlist()
  },
  methods: {
    async getlist() {
      const { data } = await this.$http.post('/getallfaq')
      if (data) {
        this.list = data.data
      }
    },
    selectlang(value) {
      this.lang = value
    },
    confirm() {
      this.$i18n.locale = this.lang
      localStorage.setItem('lang', this.lang)
      this.$router.go(-1)
    },
  },
}
</script>
<style scoped lang="less">
.van-radio {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  overflow: unset;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
</style>
